const CheckboxIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <rect
        x="11"
        y="11"
        width="18"
        height="18"
        rx="1"
        fill="white"
        stroke="#CCCCCC"
        strokeWidth="2"
      />
    </svg>
  );
};

export default CheckboxIcon;
